import { render } from "./TimelinePost.vue?vue&type=template&id=bead4a18"
import script from "./TimelinePost.vue?vue&type=script&lang=js"
export * from "./TimelinePost.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__